import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useMemo, FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useEventCallback } from 'record-it-components/hooks/useEventCallback';
import { HeaderConfig, ManageEntitiesContentLayout } from 'record-it-components/pageContentLayout/ManageEntitiesContentLayout/ManageEntitiesContentLayout';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { EntityName } from 'record-it-time-common/EntityName';
import { UserGroup } from '../../../classes/entities/UserGroup/userGroupTypes';
import { iconConfigurations } from '../../../classes/icon/iconConfigurations';
import { useEntities } from '../../../hooks/entity/useEntities/useEntities';
import { useEntityRepository } from '../../../hooks/entity/useEntityRepository';
import { useConfigureBreadcrumbsWithBuilder } from '../../../hooks/misc/useConfigureBreadcrumbsWithBuilder';
import { useEmptyCreateEntityButtonConfig } from '../../../hooks/useEmptyCreateEntityButtonConfig';
import { UserGroupList } from '../../userGroup/UserGroupList/UserGroupList';
export type UserGroupAdminPageProps = PropsWithoutChildren<Record<never, never>>;
export const UserGroupAdminPage: FunctionComponent<UserGroupAdminPageProps> = React.memo(props => {
  const $ = _c(15);
  prepareProps({
    props,
    ignoreChildren: true
  });
  useConfigureBreadcrumbsWithBuilder(_temp);
  const {
    t
  } = useTranslation();
  const userGroups = useEntities(EntityName.UserGroup, "getAll");
  const userGroupRepository = useEntityRepository(EntityName.UserGroup);
  let t0;
  if ($[0] !== userGroupRepository) {
    t0 = () => {
      userGroupRepository.create({});
    };
    $[0] = userGroupRepository;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleCreateEntity = useEventCallback(t0);
  let t1;
  if ($[2] !== t) {
    t1 = t("components.page.UserGroupAdminPage.createEntity");
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== handleCreateEntity || $[5] !== t1) {
    t2 = {
      onCreateEntity: handleCreateEntity,
      text: t1
    };
    $[4] = handleCreateEntity;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const createEntityButtonConfig = useEmptyCreateEntityButtonConfig(t2);
  let t3;
  if ($[7] !== t) {
    t3 = t("components.page.UserGroupAdminPage.pageTitle");
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t3) {
    t4 = {
      iconConfig: iconConfigurations.prefixed.page.UserGroupAdminPage.titleIcon,
      title: t3
    };
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const headerConfig = t4;
  const renderEntities = _temp2;
  let t5;
  if ($[11] !== createEntityButtonConfig || $[12] !== headerConfig || $[13] !== userGroups) {
    t5 = <ManageEntitiesContentLayout createEntityButtonConfig={createEntityButtonConfig} headerConfig={headerConfig} entities={userGroups} renderEntities={renderEntities} />;
    $[11] = createEntityButtonConfig;
    $[12] = headerConfig;
    $[13] = userGroups;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
});
function _temp(builder) {
  return builder.addHomePage().addUserGroupAdminPage();
}
function _temp2(currentPageUserGroups) {
  return <UserGroupList userGroups={currentPageUserGroups} />;
}